import * as Scrivito from "scrivito";

import searchResultsIcon from "assets/images/search_results_obj.svg";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageProperties,
  defaultPageValidations,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("SearchPage", {
  title: "Search Page",
  hideInSelectionDialogs: true,
  thumbnail: searchResultsIcon,
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [...defaultPageProperties, "backgroundImage"],
  propertiesGroups: defaultPropertiesGroups,
  validations: [...defaultPageValidations, ...metadataValidations],
});
